/**
 * JavaScript for Theme setting.
 */

// window size
export function window_size() {
  let windowWidth;
  let windowheight;
  let scrollbarWidth;
  let headerupperheight;
  let headerheight;
  let navheight;
  let footerheight;
  let breadcrumbsheight;
  let updownheight;

  // ページ読み込み時
  window.addEventListener('DOMContentLoaded', function(){
    // ブラウザ内の表示域(スクロールバーを除く)
    windowWidth = document.documentElement.clientWidth;
    windowheight = document.documentElement.clientHeight;
    scrollbarWidth = window.innerWidth - windowWidth;
    if ( document.getElementById('site-header-upper') === null ) {
      headerupperheight = 0;
    } else {
      headerupperheight = document.getElementById('site-header-upper').clientHeight;
    }
    if ( document.getElementById('site-header') === null ) {
      headerheight = 0;
    } else {
      headerheight = document.getElementById('site-header').clientHeight;
    }
    if ( document.getElementById('global-nav') === null ) {
      navheight = 0;
    } else {
      navheight = document.getElementById('global-nav').clientHeight;
    }
    // if ( document.getElementById('site-footer') === null ) {
    //   footerheight = 0;
    // } else {
    //   footerheight = document.getElementById('site-footer').clientHeight;
    // }
    // if ( document.getElementById('breadcrumbs') === null ) {
    //   breadcrumbsheight = 0;
    // } else {
    //   breadcrumbsheight = document.getElementById('breadcrumbs').clientHeight;
    // }
    // updownheight = headerheight + navheight + breadcrumbsheight + footerheight;

    document.documentElement.style.setProperty('--window-width', windowWidth);
    document.documentElement.style.setProperty('--window-height', windowheight);
    document.documentElement.style.setProperty('--window-width-px', (windowWidth) + 'px');
    document.documentElement.style.setProperty('--window-height-px', (windowheight) + 'px');
    document.documentElement.style.setProperty('--header-upper-height-px', (headerupperheight) + 'px');
    document.documentElement.style.setProperty('--header-height-px', (headerheight) + 'px');
    document.documentElement.style.setProperty('--nav-height', navheight);
    document.documentElement.style.setProperty('--nav-height-px', (navheight) + 'px');
    // document.documentElement.style.setProperty('--footer-height-px', (footerheight) + 'px');
    // document.documentElement.style.setProperty('--updown-height-px', (updownheight) + 'px');
    document.documentElement.style.setProperty('--scrollbar-width-px', (scrollbarWidth) + 'px');
  });

  // ウィンドウのサイズ変更イベントの設定
  window.addEventListener('resize', function(){
    windowWidth = document.documentElement.clientWidth;
    windowheight = document.documentElement.clientHeight;
    scrollbarWidth = window.innerWidth - windowWidth;
    if ( document.getElementById('site-header-upper') === null ) {
      headerupperheight = 0;
    } else {
      headerupperheight = document.getElementById('site-header-upper').clientHeight;
    }
    if ( document.getElementById('site-header') === null ) {
      headerheight = 0;
    } else {
      headerheight = document.getElementById('site-header').clientHeight;
    }
    if ( document.getElementById('global-nav') === null ) {
      navheight = 0;
    } else {
      navheight = document.getElementById('global-nav').clientHeight;
    }
    // if ( document.getElementById('site-footer') === null ) {
    //   footerheight = 0;
    // } else {
    //   footerheight = document.getElementById('site-footer').clientHeight;
    // }
    // if ( document.getElementById('breadcrumbs') === null ) {
    //   breadcrumbsheight = 0;
    // } else {
    //   breadcrumbsheight = document.getElementById('breadcrumbs').clientHeight;
    // }
    // updownheight = headerheight + breadcrumbsheight + footerheight;
    document.documentElement.style.setProperty('--window-width', windowWidth);
    document.documentElement.style.setProperty('--window-height', windowheight);
    document.documentElement.style.setProperty('--window-width-px', (windowWidth) + 'px');
    document.documentElement.style.setProperty('--window-height-px', (windowheight) + 'px');
    document.documentElement.style.setProperty('--header-upper-height-px', (headerupperheight) + 'px');
    document.documentElement.style.setProperty('--header-height-px', (headerheight) + 'px');
    document.documentElement.style.setProperty('--nav-height', navheight);
    document.documentElement.style.setProperty('--nav-height-px', (navheight) + 'px');
    // document.documentElement.style.setProperty('--footer-height-px', (footerheight) + 'px');
    // document.documentElement.style.setProperty('--updown-height-px', (updownheight) + 'px');
    document.documentElement.style.setProperty('--scrollbar-width-px', (scrollbarWidth) + 'px');
  });
}

// 360px 未満は JS で viewport を固定する
export function viewport_less() {
  !(function () {
    const viewport = document.querySelector('meta[name="viewport"]');
    function switchViewport() {
      const value =
        window.outerWidth > 360
          ? 'width=device-width,initial-scale=1'
          : 'width=360';
      if (viewport.getAttribute('content') !== value) {
        viewport.setAttribute('content', value);
      }
    }
    addEventListener('resize', switchViewport, false);
    switchViewport();
  })();
}
